import { render } from "./AdminUIPanel.vue?vue&type=template&id=044f2590&scoped=true&ts=true"
import script from "./AdminUIPanel.vue?vue&type=script&lang=ts"
export * from "./AdminUIPanel.vue?vue&type=script&lang=ts"

import "./AdminUIPanel.vue?vue&type=style&index=0&id=044f2590&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044f2590"]])

export default __exports__